import React from 'react';
import "./styles.css"

class About extends React.Component{
    render(){
      return(
          <div class="body">
<p><b>Safari Ticket</b> was mainly designed to simplify the booking system.The system makes it easy to book for Travels, but not only travels ,
also Accomodation , Fast Food and Fast driver . Our services have maily enriched on the welfare , well being and safety of our clients.
In Safari Ticket all payments are made online by either mobile money or banking system.
Safari Ticket patnered with atmost all buses that are favourable and safe to our clients ,
since our clients safety and happiness is our top priority during the travel.</p>
<br/>

       <h1>Our Mission</h1>
<p>Our quest is to manage business Travel and fulfill vacation dreams through our commitment to personalized, world-class service.
    We are committed to excellence in providing compassionate, personalized travels.</p>
    <br/>
       <h1>Our Vision</h1>
<p>We manage almost every type of travel need, from simplest to the complex, 
    and create an unparalled experience that our customers could rely on. We aim t o maintain <b>our vision</b>
    of high class travel service at reasonable price through consistent leadersgip, controlled 
    <b>growth</b> and excellent commitment</p>
    <br/>
       <h1>Our Value</h1>
<p>To be a progressive regulator advancing consumer protection, ethical business practices and a trusted marketplace
    where consumers are confident purchasing travel from registered proffessionals.
</p>
     <br/><br/>

          </div>
      );
    }
}
export default About;